// https://simplisafe.atlassian.net/wiki/spaces/EIS/pages/3572367673/HOWTO+Set+up+LiveChat#App-IDs
export const salesChatAppId = '626696cc6182941d123c335e_app_1252162'
export const supportChatAppId = '610bd23d07ea1e23ca931dd8_app_979960'
